import React from 'react'
import { Typography } from 'antd'
import { TitleProps } from 'antd/lib/typography/Title'

export const Heading: React.FC<TitleProps> = props => (
  <Typography.Title {...props} />
)
